var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJewelry3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type1_x5F_jewelry:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__9_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M397.3,446.8c-23,2.2-47.5,1.1-70.7,0.4c-8.5-0.2-17.3-0.9-25.6-2.7c-5.2-1.2-12.2-2.5-17-5.3 c-1.4,2.7-4,6.9-5.8,8.8c5.2,3.5,15.1,6.3,20.6,7.5c8.3,1.9,20.1,3.1,28.6,3.4c23.2,0.7,46.5,1.2,69.5-1 c11.2-1.1,29.9-3.4,39.1-11c-1.7-2.1-3.8-5.5-5-8C421.4,445.3,408.3,445.8,397.3,446.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M415.8,455.2c-17.7,7.7-37.6,14.3-56,17.4c0,1.1,0.1,2.3,0.2,3.4c21.4-3.8,50.8-13.8,70.3-25.4 C426,452.6,421,454.1,415.8,455.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2310",
    d: "M288.4,452.6c19.7,9.8,44.5,19.3,65.6,23.3c0.2-1.2,0.4-2.3,0.8-3.4c-16.8-3.1-34.8-9.1-51.2-16.1 c-1.7-0.3-3.2-0.6-4.7-0.9C296.1,454.9,292.2,453.9,288.4,452.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#382E29",
    d: "M365.3,481.1h-18.6c-0.1,0.2-0.1,0.5,0.1,0.9l9.7,16.7l9.6-16.2C366.5,481.6,365.8,481.1,365.3,481.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,480.7h-20.4c-0.3,0-0.8,0.1-0.9,0.4h18.6c0.5,0,1.2,0.5,0.7,1.4l-9.6,16.2l0.2,0.4c0.7,0.9,1.4,0.9,2-0.1l10-17 C369.1,481.2,368.5,480.7,368,480.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A29E",
    d: "M356.4,496.8l-8-13.3c-0.7-2.1,1.2-2,1.7-0.7L356.4,496.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A29E",
    d: "M352,481.4c-1.2-0.1-2,0.8-0.1,1l13.2-0.6L352,481.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3CE5B",
    d: "M360.6,476.7c0,0.6-0.4,1-1,1h-5.2c-0.6,0-1-0.4-1-1v-4.4c0-0.6,0.4-1,1-1h5.2c0.6,0,1,0.4,1,1V476.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7D86D",
    d: "M354.9,476.3v-3.7c0-0.5,0.4-0.8,0.8-0.8h-1c-0.5,0-0.8,0.4-0.8,0.8v3.7c0,0.5,0.4,0.8,0.8,0.8h1 C355.3,477.2,354.9,476.8,354.9,476.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3CE5B",
    d: "M359,478.2c0-0.2,0-0.3,0-0.5h-4c0,0.2,0,0.3,0,0.5v2.5h4V478.2L359,478.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3A64D",
    d: "M359,477.7h-4v0.1l4,0.3C359,477.9,359,477.8,359,477.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJewelry3);
export default __webpack_public_path__ + "static/media/new_jewelry_3.cb8eb0e8da379141615a5ea04163ce97.svg";
export { ForwardRef as ReactComponent };